// kapigen version 0.1.33
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
export var AddTestNotificationRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.notificationType) {
            wireFormat.notificationType = NotificationTypeWireFormat3.toJson(message.notificationType);
        }
        return wireFormat;
    }
};
var defaultAddTestNotificationResponse = {
    notificationId: 0,
    emailsProcessedCount: 0
};
export var AddTestNotificationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAddTestNotificationResponse, wireFormat);
        return message;
    }
};
export var GetMySubscribeStateRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = SubscriptionTypeWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
var defaultGetSubscribeStateResponse = {};
export var GetSubscribeStateResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSubscribeStateResponse, wireFormat);
        if (wireFormat) {
            message.state = SubscribeStateWireFormat3.fromJson(wireFormat.state);
        }
        return message;
    }
};
export var GetUserNotificationSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserNotificationSettingsResponse = {};
export var GetUserNotificationSettingsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserNotificationSettingsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.settings) {
            message.settings = UserNotificationSettingsWireFormat3.fromJson(wireFormat.settings);
        }
        return message;
    }
};
export var GetUserNotificationsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserNotificationsResponse = {
    containsMore: false,
    enabled: false,
    countUnviewed: 0,
    notifications: [],
    newestNotificationId: 0,
    cacheIsValid: false
};
export var GetUserNotificationsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserNotificationsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.notifications) {
            message.notifications = wireFormat.notifications.map(function(i) {
                return NotificationWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var MarkAllNotificationsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.commandMark) {
            wireFormat.commandMark = CommandMarkWireFormat3.toJson(message.commandMark);
        }
        return wireFormat;
    }
};
export var MarkNotificationsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultMessageObject = {};
export var MessageObjectWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultMessageObject, wireFormat);
        return message;
    }
};
var defaultNotification = {
    id: 0,
    relatedItemId: 0,
    isRead: false,
    isViewed: false,
    messageObjects: []
};
export var NotificationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultNotification, wireFormat);
        if (wireFormat) {
            message.subscriptionType = SubscriptionTypeWireFormat3.fromJson(wireFormat.subscriptionType);
        }
        if (wireFormat) {
            message.relatedItemType = NotificationRelatedItemTypeWireFormat3.fromJson(wireFormat.relatedItemType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createdDate) {
            message.createdDate = new Date(wireFormat.createdDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.messageObjects) {
            message.messageObjects = wireFormat.messageObjects.map(function(i) {
                return MessageObjectWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SetUserNotificationSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settings) {
            wireFormat.settings = UserNotificationSettingsWireFormat3.toJson(message.settings);
        }
        if (message === null || message === void 0 ? void 0 : message.updateMask) {
            var _paths;
            wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var SubscribeToRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.subscribe) {
            wireFormat.subscribe = SubscribeStateWireFormat3.toJson(message.subscribe);
        }
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = SubscriptionTypeWireFormat3.toJson(message.type);
        }
        if (message === null || message === void 0 ? void 0 : message.parentType) {
            wireFormat.parentType = NotificationRelatedItemTypeWireFormat3.toJson(message.parentType);
        }
        return wireFormat;
    }
};
var defaultUserNotificationSettings = {
    enabled: false,
    subscriptions: [],
    isSubscribedToMailingList: false
};
export var UserNotificationSettingsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserNotificationSettings, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.subscriptions) {
            message.subscriptions = wireFormat.subscriptions.map(function(i) {
                return UserSubscriptionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.aggregation = NotificationAggregationOptionWireFormat3.fromJson(wireFormat.aggregation);
        }
        if (wireFormat) {
            message.datasetSummaryEmail = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.datasetSummaryEmail);
        }
        if (wireFormat) {
            message.privateDatasetSummaryEmail = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.privateDatasetSummaryEmail);
        }
        if (wireFormat) {
            message.userCollaborationMessages = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.userCollaborationMessages);
        }
        if (wireFormat) {
            message.atMentionFollowedUser = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.atMentionFollowedUser);
        }
        if (wireFormat) {
            message.atMentionRegularUser = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.atMentionRegularUser);
        }
        if (wireFormat) {
            message.competitionAnnouncements = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.competitionAnnouncements);
        }
        if (wireFormat) {
            message.competitionTeamUpdates = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.competitionTeamUpdates);
        }
        if (wireFormat) {
            message.datasetAlerts = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.datasetAlerts);
        }
        if (wireFormat) {
            message.notebookAlerts = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.notebookAlerts);
        }
        if (wireFormat) {
            message.engagedTopicComment = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.engagedTopicComment);
        }
        if (wireFormat) {
            message.userNewFollower = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.userNewFollower);
        }
        if (wireFormat) {
            message.newTopic = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.newTopic);
        }
        if (wireFormat) {
            message.newTierAchievedOrMedal = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.newTierAchievedOrMedal);
        }
        if (wireFormat) {
            message.topicUpvote = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.topicUpvote);
        }
        if (wireFormat) {
            message.topicComment = NotificationDeliveryTypeWireFormat3.fromJson(wireFormat.topicComment);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.subscriptions) {
            wireFormat.subscriptions = message.subscriptions.map(function(i) {
                return UserSubscriptionWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.aggregation) {
            wireFormat.aggregation = NotificationAggregationOptionWireFormat3.toJson(message.aggregation);
        }
        if (message === null || message === void 0 ? void 0 : message.datasetSummaryEmail) {
            wireFormat.datasetSummaryEmail = NotificationDeliveryTypeWireFormat3.toJson(message.datasetSummaryEmail);
        }
        if (message === null || message === void 0 ? void 0 : message.privateDatasetSummaryEmail) {
            wireFormat.privateDatasetSummaryEmail = NotificationDeliveryTypeWireFormat3.toJson(message.privateDatasetSummaryEmail);
        }
        if (message === null || message === void 0 ? void 0 : message.userCollaborationMessages) {
            wireFormat.userCollaborationMessages = NotificationDeliveryTypeWireFormat3.toJson(message.userCollaborationMessages);
        }
        if (message === null || message === void 0 ? void 0 : message.atMentionFollowedUser) {
            wireFormat.atMentionFollowedUser = NotificationDeliveryTypeWireFormat3.toJson(message.atMentionFollowedUser);
        }
        if (message === null || message === void 0 ? void 0 : message.atMentionRegularUser) {
            wireFormat.atMentionRegularUser = NotificationDeliveryTypeWireFormat3.toJson(message.atMentionRegularUser);
        }
        if (message === null || message === void 0 ? void 0 : message.competitionAnnouncements) {
            wireFormat.competitionAnnouncements = NotificationDeliveryTypeWireFormat3.toJson(message.competitionAnnouncements);
        }
        if (message === null || message === void 0 ? void 0 : message.competitionTeamUpdates) {
            wireFormat.competitionTeamUpdates = NotificationDeliveryTypeWireFormat3.toJson(message.competitionTeamUpdates);
        }
        if (message === null || message === void 0 ? void 0 : message.datasetAlerts) {
            wireFormat.datasetAlerts = NotificationDeliveryTypeWireFormat3.toJson(message.datasetAlerts);
        }
        if (message === null || message === void 0 ? void 0 : message.notebookAlerts) {
            wireFormat.notebookAlerts = NotificationDeliveryTypeWireFormat3.toJson(message.notebookAlerts);
        }
        if (message === null || message === void 0 ? void 0 : message.engagedTopicComment) {
            wireFormat.engagedTopicComment = NotificationDeliveryTypeWireFormat3.toJson(message.engagedTopicComment);
        }
        if (message === null || message === void 0 ? void 0 : message.userNewFollower) {
            wireFormat.userNewFollower = NotificationDeliveryTypeWireFormat3.toJson(message.userNewFollower);
        }
        if (message === null || message === void 0 ? void 0 : message.newTopic) {
            wireFormat.newTopic = NotificationDeliveryTypeWireFormat3.toJson(message.newTopic);
        }
        if (message === null || message === void 0 ? void 0 : message.newTierAchievedOrMedal) {
            wireFormat.newTierAchievedOrMedal = NotificationDeliveryTypeWireFormat3.toJson(message.newTierAchievedOrMedal);
        }
        if (message === null || message === void 0 ? void 0 : message.topicUpvote) {
            wireFormat.topicUpvote = NotificationDeliveryTypeWireFormat3.toJson(message.topicUpvote);
        }
        if (message === null || message === void 0 ? void 0 : message.topicComment) {
            wireFormat.topicComment = NotificationDeliveryTypeWireFormat3.toJson(message.topicComment);
        }
        return wireFormat;
    }
};
var defaultUserSubscription = {
    id: 0,
    subscriptionStateId: 0,
    subscriptionType: "",
    name: "",
    kernelName: "",
    notificationCount: 0,
    link: ""
};
export var UserSubscriptionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserSubscription, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastNotificationCreatedDate) {
            message.lastNotificationCreatedDate = new Date(wireFormat.lastNotificationCreatedDate);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.lastNotificationCreatedDate) {
            wireFormat.lastNotificationCreatedDate = message.lastNotificationCreatedDate.toISOString();
        }
        return wireFormat;
    }
};
export var CommandMark;
(function(CommandMark) {
    CommandMark["READ"] = "read";
    CommandMark["VIEWED"] = "viewed";
})(CommandMark || (CommandMark = {}));
export var CommandMarkWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CommandMark.READ:
            case 0:
            default:
                return "READ";
            case CommandMark.VIEWED:
            case 1:
                return "VIEWED";
        }
    }
};
export var NotificationAggregationOption;
(function(NotificationAggregationOption) {
    NotificationAggregationOption["NO_AGGREGATION"] = "noAggregation";
    NotificationAggregationOption["DAILY"] = "daily";
    NotificationAggregationOption["WEEKLY"] = "weekly";
})(NotificationAggregationOption || (NotificationAggregationOption = {}));
export var NotificationAggregationOptionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NOTIFICATION_AGGREGATION_OPTION_NO_AGGREGATION":
            default:
                return NotificationAggregationOption.NO_AGGREGATION;
            case "NOTIFICATION_AGGREGATION_OPTION_DAILY":
                return NotificationAggregationOption.DAILY;
            case "NOTIFICATION_AGGREGATION_OPTION_WEEKLY":
                return NotificationAggregationOption.WEEKLY;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case NotificationAggregationOption.NO_AGGREGATION:
            case 0:
            default:
                return "NOTIFICATION_AGGREGATION_OPTION_NO_AGGREGATION";
            case NotificationAggregationOption.DAILY:
            case 1:
                return "NOTIFICATION_AGGREGATION_OPTION_DAILY";
            case NotificationAggregationOption.WEEKLY:
            case 2:
                return "NOTIFICATION_AGGREGATION_OPTION_WEEKLY";
        }
    }
};
export var NotificationDeliveryType;
(function(NotificationDeliveryType) {
    NotificationDeliveryType["NONE"] = "none";
    NotificationDeliveryType["WEB"] = "web";
    NotificationDeliveryType["EMAIL"] = "email";
    NotificationDeliveryType["BOTH"] = "both";
})(NotificationDeliveryType || (NotificationDeliveryType = {}));
export var NotificationDeliveryTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NOTIFICATION_DELIVERY_TYPE_NONE":
            default:
                return NotificationDeliveryType.NONE;
            case "NOTIFICATION_DELIVERY_TYPE_WEB":
                return NotificationDeliveryType.WEB;
            case "NOTIFICATION_DELIVERY_TYPE_EMAIL":
                return NotificationDeliveryType.EMAIL;
            case "NOTIFICATION_DELIVERY_TYPE_BOTH":
                return NotificationDeliveryType.BOTH;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case NotificationDeliveryType.NONE:
            case 0:
            default:
                return "NOTIFICATION_DELIVERY_TYPE_NONE";
            case NotificationDeliveryType.WEB:
            case 1:
                return "NOTIFICATION_DELIVERY_TYPE_WEB";
            case NotificationDeliveryType.EMAIL:
            case 2:
                return "NOTIFICATION_DELIVERY_TYPE_EMAIL";
            case NotificationDeliveryType.BOTH:
            case 3:
                return "NOTIFICATION_DELIVERY_TYPE_BOTH";
        }
    }
};
export var NotificationRelatedItemType;
(function(NotificationRelatedItemType) {
    NotificationRelatedItemType["UNSPECIFIED"] = "unspecified";
    NotificationRelatedItemType["FORUM_MESSAGE"] = "forumMessage";
    NotificationRelatedItemType["KERNEL"] = "kernel";
    NotificationRelatedItemType["KERNEL_RUN"] = "kernelRun";
    NotificationRelatedItemType["USER_TIER_LOG"] = "userTierLog";
    NotificationRelatedItemType["USER_MEDAL"] = "userMedal";
    NotificationRelatedItemType["COMPETITION"] = "competition";
    NotificationRelatedItemType["DATASET"] = "dataset";
    NotificationRelatedItemType["TEAM"] = "team";
    NotificationRelatedItemType["DATASET_TASK"] = "datasetTask";
    NotificationRelatedItemType["DATASET_TASK_SOLUTION"] = "datasetTaskSolution";
    NotificationRelatedItemType["USER"] = "user";
    NotificationRelatedItemType["USER_PENALTY"] = "userPenalty";
})(NotificationRelatedItemType || (NotificationRelatedItemType = {}));
export var NotificationRelatedItemTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NOTIFICATION_RELATED_ITEM_TYPE_UNSPECIFIED":
            default:
                return NotificationRelatedItemType.UNSPECIFIED;
            case "NOTIFICATION_RELATED_ITEM_TYPE_FORUM_MESSAGE":
                return NotificationRelatedItemType.FORUM_MESSAGE;
            case "NOTIFICATION_RELATED_ITEM_TYPE_KERNEL":
                return NotificationRelatedItemType.KERNEL;
            case "NOTIFICATION_RELATED_ITEM_TYPE_KERNEL_RUN":
                return NotificationRelatedItemType.KERNEL_RUN;
            case "NOTIFICATION_RELATED_ITEM_TYPE_USER_TIER_LOG":
                return NotificationRelatedItemType.USER_TIER_LOG;
            case "NOTIFICATION_RELATED_ITEM_TYPE_USER_MEDAL":
                return NotificationRelatedItemType.USER_MEDAL;
            case "NOTIFICATION_RELATED_ITEM_TYPE_COMPETITION":
                return NotificationRelatedItemType.COMPETITION;
            case "NOTIFICATION_RELATED_ITEM_TYPE_DATASET":
                return NotificationRelatedItemType.DATASET;
            case "NOTIFICATION_RELATED_ITEM_TYPE_TEAM":
                return NotificationRelatedItemType.TEAM;
            case "NOTIFICATION_RELATED_ITEM_TYPE_DATASET_TASK":
                return NotificationRelatedItemType.DATASET_TASK;
            case "NOTIFICATION_RELATED_ITEM_TYPE_DATASET_TASK_SOLUTION":
                return NotificationRelatedItemType.DATASET_TASK_SOLUTION;
            case "NOTIFICATION_RELATED_ITEM_TYPE_USER":
                return NotificationRelatedItemType.USER;
            case "NOTIFICATION_RELATED_ITEM_TYPE_USER_PENALTY":
                return NotificationRelatedItemType.USER_PENALTY;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case NotificationRelatedItemType.UNSPECIFIED:
            case 0:
            default:
                return "NOTIFICATION_RELATED_ITEM_TYPE_UNSPECIFIED";
            case NotificationRelatedItemType.FORUM_MESSAGE:
            case 1:
                return "NOTIFICATION_RELATED_ITEM_TYPE_FORUM_MESSAGE";
            case NotificationRelatedItemType.KERNEL:
            case 2:
                return "NOTIFICATION_RELATED_ITEM_TYPE_KERNEL";
            case NotificationRelatedItemType.KERNEL_RUN:
            case 3:
                return "NOTIFICATION_RELATED_ITEM_TYPE_KERNEL_RUN";
            case NotificationRelatedItemType.USER_TIER_LOG:
            case 4:
                return "NOTIFICATION_RELATED_ITEM_TYPE_USER_TIER_LOG";
            case NotificationRelatedItemType.USER_MEDAL:
            case 5:
                return "NOTIFICATION_RELATED_ITEM_TYPE_USER_MEDAL";
            case NotificationRelatedItemType.COMPETITION:
            case 6:
                return "NOTIFICATION_RELATED_ITEM_TYPE_COMPETITION";
            case NotificationRelatedItemType.DATASET:
            case 7:
                return "NOTIFICATION_RELATED_ITEM_TYPE_DATASET";
            case NotificationRelatedItemType.TEAM:
            case 8:
                return "NOTIFICATION_RELATED_ITEM_TYPE_TEAM";
            case NotificationRelatedItemType.DATASET_TASK:
            case 9:
                return "NOTIFICATION_RELATED_ITEM_TYPE_DATASET_TASK";
            case NotificationRelatedItemType.DATASET_TASK_SOLUTION:
            case 10:
                return "NOTIFICATION_RELATED_ITEM_TYPE_DATASET_TASK_SOLUTION";
            case NotificationRelatedItemType.USER:
            case 11:
                return "NOTIFICATION_RELATED_ITEM_TYPE_USER";
            case NotificationRelatedItemType.USER_PENALTY:
            case 12:
                return "NOTIFICATION_RELATED_ITEM_TYPE_USER_PENALTY";
        }
    }
};
export var NotificationType;
(function(NotificationType) {
    NotificationType["UNSPECIFIED"] = "unspecified";
    NotificationType["TOPIC_COMMENT"] = "topicComment";
    NotificationType["AT_MENTION"] = "atMention";
    NotificationType["TOPIC_UPVOTE"] = "topicUpvote";
    NotificationType["NEW_TOPIC"] = "newTopic";
    NotificationType["NEW_KERNEL_VERSION"] = "newKernelVersion";
    NotificationType["USER_NEW_TIER_ACHIEVED"] = "userNewTierAchieved";
    NotificationType["NEW_MEDAL"] = "newMedal";
    NotificationType["USER_NEW_FOLLOWER"] = "userNewFollower";
    NotificationType["NOTEBOOK_FINISHED_RUNNING"] = "notebookFinishedRunning";
    NotificationType["NOTEBOOK_MADE_PUBLIC"] = "notebookMadePublic";
    NotificationType["NOTEBOOK_FORK_COUNT"] = "notebookForkCount";
    NotificationType["NOTEBOOK_FEATURED"] = "notebookFeatured";
    NotificationType["NOTEBOOK_VIEW_COUNT"] = "notebookViewCount";
    NotificationType["NOTEBOOK_DISCUSSION_COUNT"] = "notebookDiscussionCount";
    NotificationType["NOTEBOOK_GITHUB_COMMIT"] = "notebookGithubCommit";
    NotificationType["COMPETITION_DEADLINE_ONE_DAY"] = "competitionDeadlineOneDay";
    NotificationType["COMPETITION_DEADLINE_ONE_WEEK"] = "competitionDeadlineOneWeek";
    NotificationType["COMPETITION_FINALIZED"] = "competitionFinalized";
    NotificationType["COMPETITION_TEAM_MERGE"] = "competitionTeamMerge";
    NotificationType["COMPETITION_TEAM_INVITE"] = "competitionTeamInvite";
    NotificationType["COMPETITION_NOTEBOOK_COUNT"] = "competitionNotebookCount";
    NotificationType["COMPETITION_SUBMISSION_COUNT"] = "competitionSubmissionCount";
    NotificationType["COMPETITION_ENTRANT_COUNT"] = "competitionEntrantCount";
    NotificationType["DATASET_NEW_PUBLIC_NOTEBOOK"] = "datasetNewPublicNotebook";
    NotificationType["DATASET_NEW_TASK"] = "datasetNewTask";
    NotificationType["DATASET_NEW_TASK_SOLUTION"] = "datasetNewTaskSolution";
    NotificationType["DATASET_PUBLISHED"] = "datasetPublished";
    NotificationType["DATASET_UPLOADED"] = "datasetUploaded";
    NotificationType["ACCOUNT_ALERT"] = "accountAlert";
    NotificationType["DATASET_NOTEBOOK_COUNT"] = "datasetNotebookCount";
    NotificationType["DATASET_PARTICIPATION_COUNT"] = "datasetParticipationCount";
    NotificationType["DATASET_TRENDING"] = "datasetTrending";
    NotificationType["DATASET_VIEW_COUNT"] = "datasetViewCount";
    NotificationType["DATASET_DOWNLOAD_COUNT"] = "datasetDownloadCount";
    NotificationType["MODERATION_USER_PENALTY"] = "moderationUserPenalty";
})(NotificationType || (NotificationType = {}));
export var NotificationTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case NotificationType.UNSPECIFIED:
            case 0:
            default:
                return "NOTIFICATION_TYPE_UNSPECIFIED";
            case NotificationType.TOPIC_COMMENT:
            case 1:
                return "NOTIFICATION_TYPE_TOPIC_COMMENT";
            case NotificationType.AT_MENTION:
            case 2:
                return "NOTIFICATION_TYPE_AT_MENTION";
            case NotificationType.TOPIC_UPVOTE:
            case 3:
                return "NOTIFICATION_TYPE_TOPIC_UPVOTE";
            case NotificationType.NEW_TOPIC:
            case 4:
                return "NOTIFICATION_TYPE_NEW_TOPIC";
            case NotificationType.NEW_KERNEL_VERSION:
            case 5:
                return "NOTIFICATION_TYPE_NEW_KERNEL_VERSION";
            case NotificationType.USER_NEW_TIER_ACHIEVED:
            case 6:
                return "NOTIFICATION_TYPE_USER_NEW_TIER_ACHIEVED";
            case NotificationType.NEW_MEDAL:
            case 7:
                return "NOTIFICATION_TYPE_NEW_MEDAL";
            case NotificationType.USER_NEW_FOLLOWER:
            case 8:
                return "NOTIFICATION_TYPE_USER_NEW_FOLLOWER";
            case NotificationType.NOTEBOOK_FINISHED_RUNNING:
            case 20:
                return "NOTIFICATION_TYPE_NOTEBOOK_FINISHED_RUNNING";
            case NotificationType.NOTEBOOK_MADE_PUBLIC:
            case 21:
                return "NOTIFICATION_TYPE_NOTEBOOK_MADE_PUBLIC";
            case NotificationType.NOTEBOOK_FORK_COUNT:
            case 22:
                return "NOTIFICATION_TYPE_NOTEBOOK_FORK_COUNT";
            case NotificationType.NOTEBOOK_FEATURED:
            case 23:
                return "NOTIFICATION_TYPE_NOTEBOOK_FEATURED";
            case NotificationType.NOTEBOOK_VIEW_COUNT:
            case 24:
                return "NOTIFICATION_TYPE_NOTEBOOK_VIEW_COUNT";
            case NotificationType.NOTEBOOK_DISCUSSION_COUNT:
            case 25:
                return "NOTIFICATION_TYPE_NOTEBOOK_DISCUSSION_COUNT";
            case NotificationType.NOTEBOOK_GITHUB_COMMIT:
            case 26:
                return "NOTIFICATION_TYPE_NOTEBOOK_GITHUB_COMMIT";
            case NotificationType.COMPETITION_DEADLINE_ONE_DAY:
            case 101:
                return "NOTIFICATION_TYPE_COMPETITION_DEADLINE_ONE_DAY";
            case NotificationType.COMPETITION_DEADLINE_ONE_WEEK:
            case 102:
                return "NOTIFICATION_TYPE_COMPETITION_DEADLINE_ONE_WEEK";
            case NotificationType.COMPETITION_FINALIZED:
            case 103:
                return "NOTIFICATION_TYPE_COMPETITION_FINALIZED";
            case NotificationType.COMPETITION_TEAM_MERGE:
            case 104:
                return "NOTIFICATION_TYPE_COMPETITION_TEAM_MERGE";
            case NotificationType.COMPETITION_TEAM_INVITE:
            case 105:
                return "NOTIFICATION_TYPE_COMPETITION_TEAM_INVITE";
            case NotificationType.COMPETITION_NOTEBOOK_COUNT:
            case 106:
                return "NOTIFICATION_TYPE_COMPETITION_NOTEBOOK_COUNT";
            case NotificationType.COMPETITION_SUBMISSION_COUNT:
            case 107:
                return "NOTIFICATION_TYPE_COMPETITION_SUBMISSION_COUNT";
            case NotificationType.COMPETITION_ENTRANT_COUNT:
            case 108:
                return "NOTIFICATION_TYPE_COMPETITION_ENTRANT_COUNT";
            case NotificationType.DATASET_NEW_PUBLIC_NOTEBOOK:
            case 200:
                return "NOTIFICATION_TYPE_DATASET_NEW_PUBLIC_NOTEBOOK";
            case NotificationType.DATASET_NEW_TASK:
            case 201:
                return "NOTIFICATION_TYPE_DATASET_NEW_TASK";
            case NotificationType.DATASET_NEW_TASK_SOLUTION:
            case 202:
                return "NOTIFICATION_TYPE_DATASET_NEW_TASK_SOLUTION";
            case NotificationType.DATASET_PUBLISHED:
            case 203:
                return "NOTIFICATION_TYPE_DATASET_PUBLISHED";
            case NotificationType.DATASET_UPLOADED:
            case 204:
                return "NOTIFICATION_TYPE_DATASET_UPLOADED";
            case NotificationType.ACCOUNT_ALERT:
            case 205:
                return "NOTIFICATION_TYPE_ACCOUNT_ALERT";
            case NotificationType.DATASET_NOTEBOOK_COUNT:
            case 206:
                return "NOTIFICATION_TYPE_DATASET_NOTEBOOK_COUNT";
            case NotificationType.DATASET_PARTICIPATION_COUNT:
            case 207:
                return "NOTIFICATION_TYPE_DATASET_PARTICIPATION_COUNT";
            case NotificationType.DATASET_TRENDING:
            case 208:
                return "NOTIFICATION_TYPE_DATASET_TRENDING";
            case NotificationType.DATASET_VIEW_COUNT:
            case 209:
                return "NOTIFICATION_TYPE_DATASET_VIEW_COUNT";
            case NotificationType.DATASET_DOWNLOAD_COUNT:
            case 210:
                return "NOTIFICATION_TYPE_DATASET_DOWNLOAD_COUNT";
            case NotificationType.MODERATION_USER_PENALTY:
            case 9:
                return "NOTIFICATION_TYPE_MODERATION_USER_PENALTY";
        }
    }
};
export var SettingsPageMessage;
(function(SettingsPageMessage) {
    SettingsPageMessage[// Previous messages for now removed emails.
    "UNSPECIFIED"] = "unspecified";
    SettingsPageMessage["UNSUBSCRIBED_DATASET_UPDATES"] = "unsubscribedDatasetUpdates";
    SettingsPageMessage["UNSUBSCRIBED_PRIVATE_DATASET_SUMMARIES"] = "unsubscribedPrivateDatasetSummaries";
    SettingsPageMessage["UNSUBSCRIBED_GENERIC"] = "unsubscribedGeneric";
    SettingsPageMessage["UNSUBSCRIBED_COLLABORATION"] = "unsubscribedCollaboration";
})(SettingsPageMessage || (SettingsPageMessage = {}));
export var SubscribeState;
(function(SubscribeState) {
    SubscribeState["INVALID"] = "invalid";
    SubscribeState["UNSUBSCRIBE"] = "unsubscribe";
    SubscribeState[// out of date, do not use except for back compat 
    "SUBSCRIBE_SINGLE"] = "subscribeSingle";
    SubscribeState["SUBSCRIBE_ALL"] = "subscribeAll";
    SubscribeState[// Forums 
    "FORUM_NEW_TOPICS"] = "forumNewTopics";
    SubscribeState["FORUM_NEW_TOPICS_AND_COMMENTS"] = "forumNewTopicsAndComments";
    SubscribeState[// Topic 
    "TOPIC_NEW_COMMENTS"] = "topicNewComments";
    SubscribeState[// Kernels 
    "KERNEL_NEW_COMMENTS"] = "kernelNewComments";
    SubscribeState["KERNEL_NEW_COMMENTS_AND_VERSIONS"] = "kernelNewCommentsAndVersions";
})(SubscribeState || (SubscribeState = {}));
export var SubscribeStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "INVALID":
            default:
                return SubscribeState.INVALID;
            case "UNSUBSCRIBE":
                return SubscribeState.UNSUBSCRIBE;
            case "SUBSCRIBE_SINGLE":
                return SubscribeState.SUBSCRIBE_SINGLE;
            case "SUBSCRIBE_ALL":
                return SubscribeState.SUBSCRIBE_ALL;
            case "FORUM_NEW_TOPICS":
                return SubscribeState.FORUM_NEW_TOPICS;
            case "FORUM_NEW_TOPICS_AND_COMMENTS":
                return SubscribeState.FORUM_NEW_TOPICS_AND_COMMENTS;
            case "TOPIC_NEW_COMMENTS":
                return SubscribeState.TOPIC_NEW_COMMENTS;
            case "KERNEL_NEW_COMMENTS":
                return SubscribeState.KERNEL_NEW_COMMENTS;
            case "KERNEL_NEW_COMMENTS_AND_VERSIONS":
                return SubscribeState.KERNEL_NEW_COMMENTS_AND_VERSIONS;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SubscribeState.INVALID:
            case 0:
            default:
                return "INVALID";
            case SubscribeState.UNSUBSCRIBE:
            case 1:
                return "UNSUBSCRIBE";
            case SubscribeState.SUBSCRIBE_SINGLE:
            case 2:
                return "SUBSCRIBE_SINGLE";
            case SubscribeState.SUBSCRIBE_ALL:
            case 3:
                return "SUBSCRIBE_ALL";
            case SubscribeState.FORUM_NEW_TOPICS:
            case 10:
                return "FORUM_NEW_TOPICS";
            case SubscribeState.FORUM_NEW_TOPICS_AND_COMMENTS:
            case 11:
                return "FORUM_NEW_TOPICS_AND_COMMENTS";
            case SubscribeState.TOPIC_NEW_COMMENTS:
            case 20:
                return "TOPIC_NEW_COMMENTS";
            case SubscribeState.KERNEL_NEW_COMMENTS:
            case 30:
                return "KERNEL_NEW_COMMENTS";
            case SubscribeState.KERNEL_NEW_COMMENTS_AND_VERSIONS:
            case 31:
                return "KERNEL_NEW_COMMENTS_AND_VERSIONS";
        }
    }
};
export var SubscriptionType;
(function(SubscriptionType) {
    SubscriptionType["NOT_APPLICABLE"] = "notApplicable";
    SubscriptionType["FORUM_TOPIC"] = "forumTopic";
    SubscriptionType["FORUM"] = "forum";
    SubscriptionType["KERNEL"] = "kernel";
})(SubscriptionType || (SubscriptionType = {}));
export var SubscriptionTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "SUBSCRIPTION_TYPE_NOT_APPLICABLE":
            default:
                return SubscriptionType.NOT_APPLICABLE;
            case "SUBSCRIPTION_TYPE_FORUM_TOPIC":
                return SubscriptionType.FORUM_TOPIC;
            case "SUBSCRIPTION_TYPE_FORUM":
                return SubscriptionType.FORUM;
            case "SUBSCRIPTION_TYPE_KERNEL":
                return SubscriptionType.KERNEL;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SubscriptionType.NOT_APPLICABLE:
            case 0:
            default:
                return "SUBSCRIPTION_TYPE_NOT_APPLICABLE";
            case SubscriptionType.FORUM_TOPIC:
            case 1:
                return "SUBSCRIPTION_TYPE_FORUM_TOPIC";
            case SubscriptionType.FORUM:
            case 2:
                return "SUBSCRIPTION_TYPE_FORUM";
            case SubscriptionType.KERNEL:
            case 3:
                return "SUBSCRIPTION_TYPE_KERNEL";
        }
    }
};
export var notificationsClient = {
    notificationsService: {
        // directly creates a new notification in the notification table and sends email.
        addTestNotification: createClient(AddTestNotificationRequestWireFormat3, AddTestNotificationResponseWireFormat3, "notifications.NotificationsService/AddTestNotification"),
        // Get the list of notifications for the current user.
        getUserNotifications: createClient(GetUserNotificationsRequestWireFormat3, GetUserNotificationsResponseWireFormat3, "notifications.NotificationsService/GetUserNotifications"),
        // Retrieves the current user's notification settings, providing defaults if user hasn't set a value
        getUserNotificationSettings: createClient(GetUserNotificationSettingsRequestWireFormat3, GetUserNotificationSettingsResponseWireFormat3, "notifications.NotificationsService/GetUserNotificationSettings"),
        // Mark all notification as (read|viewed) for a user.
        markAllNotifications: createClient(MarkAllNotificationsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "notifications.NotificationsService/MarkAllNotifications"),
        // Set the read or viewed status on a single notification or many notifications.
        markNotifications: createClient(MarkNotificationsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "notifications.NotificationsService/MarkNotifications"),
        // Set the notification settings to the given settings, only updating any values that are actually set
        setUserNotificationSettings: createClient(SetUserNotificationSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "notifications.NotificationsService/SetUserNotificationSettings")
    },
    subscriptionService: {
        getMySubscribeState: createClient(GetMySubscribeStateRequestWireFormat3, GetSubscribeStateResponseWireFormat3, "notifications.SubscriptionService/GetMySubscribeState"),
        subscribeTo: createClient(SubscribeToRequestWireFormat3, google.protobuf.EmptyWireFormat3, "notifications.SubscriptionService/SubscribeTo")
    }
};
